import React from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { ChevronDownIcon } from '../../../../../components/psychologist/calendar/icons';

export type CalendarView = 'week' | 'month' | 'day';

export const VIEW_LABELS: Record<CalendarView, string> = {
  month: 'Vista mensual',
  week: 'Vista semanal',
  day: 'Vista diaria',
};

const VIEW_ORDER: CalendarView[] = ['month', 'week', 'day'];

interface ViewSelectorProps {
  currentView: CalendarView;
  onViewChange: (view: CalendarView) => void;
}

export const ViewSelector: React.FC<ViewSelectorProps> = ({ currentView, onViewChange }) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild data-testid="view-selector">
        <Button
          variant="default"
          size="sm"
          aria-label="selector-de-vista"
          data-testid="view-selector-trigger"
          className="gap-1.5 whitespace-nowrap"
        >
          <span>{VIEW_LABELS[currentView]}</span>
          <ChevronDownIcon />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        align="start"
        className="min-w-[12rem]"
        data-testid="view-selector-menu"
      >
        {VIEW_ORDER.map((v) => (
          <DropdownMenuItem
            key={v}
            data-testid={`view-option-${v}`}
            onClick={() => onViewChange(v)}
            className="flex items-center justify-between cursor-pointer"
          >
            <span>{VIEW_LABELS[v]}</span>
            {v === currentView && (
              <span className="text-primary font-semibold ml-4">✓</span>
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
